export const contentStudio = {
  contentStudio: {
    permissions: {
      noPermission: "You don't have permission to do this in Content Studio.",
    },
    reset: {
      resetControl: 'Reset',
      resetAll: 'Reset all',
      layersCount_one: 'Layers ({{count}})',
      layersCount_other: 'Layers ({{count}})',
      resetTarget: 'Reset {{target}}',
      unavailable: 'Imported before reset existed, so there is no default to go back to.',
      boardMenuItem: 'Reset to default',
      changedCount_one: '{{count}} value changed',
      changedCount_other: '{{count}} values changed',
      dialogTitle: 'Reset this adset to its default state?',
      dialogBody:
        'Every parameter and every piece of copy goes back to the state this adset was imported in. You can undo it.',
      dialogConfirm: 'Reset',
      dialogCancel: 'Cancel',
      done: 'Reset to default',
    },
    header: {
      breadcrumbRoot: 'Content studio',
      nameLabel: 'Adset name',
      viewsLabel: 'Content studio views',
      scopePill: 'All formats',
      scopePillNone: 'Nothing selected',
      scopePillOne: '{{name}} · {{w}} × {{h}}',
      scopePillCount_one: '{{count}} format',
      scopePillCount_other: '{{count}} formats',
      rename: 'Rename',
      boardActions: 'Adset actions',
      boardMenu: {
        duplicate: 'Duplicate',
        editCover: 'Edit cover image',
        delete: 'Delete',
      },
      changeCount_one: '{{count}} change',
      changeCount_other: '{{count}} changes',
      discard: 'Discard',
      save: 'Save',
      saving: 'Saving…',
      saveConflictTitle: 'This draft changed elsewhere',
      saveConflictDescription: 'Reload the latest version and reapply your changes.',
      saveFailure: "Couldn't save the draft. Try again.",
      changeRejected:
        "That value isn't allowed on every format it would apply to, so the change was undone.",
      changeRefused: "Couldn't save that change: {{reason}}",
      changeRefusedGeneric: "Couldn't save that change. It was undone.",
      undoFailure: "Couldn't undo. Try again.",
      redoFailure: "Couldn't redo. Try again.",
      staleChangeTitle: 'You are on an old version',
      staleChangeDescription: 'Refreshing so you can keep editing. Your changes will be reapplied.',
      staleChangeBannerTitle: 'Your view is out of date',
      staleChangeBannerDescription:
        "Someone else changed this draft, so your last edit didn't save. Refresh to see the latest version before editing again.",
      staleChangeBannerAction: 'Refresh',
      focus: 'Focus',
      hideTabBar: 'Hide the tab bar',
      showTabBar: 'Show the tab bar',
    },
    motion: {
      scenes: 'Scenes',
      readout: '{{current}}s / {{total}}s',
      allLayers: 'All layers',
      showLanes: 'Show layer timeline',
      hideLanes: 'Hide layer timeline',
      play: 'Play',
      pause: 'Pause',
      loop: 'Loop',
      previousScene: 'Previous scene',
      nextScene: 'Next scene',
      previousFrame: 'Previous frame',
      nextFrame: 'Next frame',
      timeline: 'Timeline',
      scrub: 'Scrub the timeline',
      noMotion: 'Nothing on this board moves yet.',
      duration: 'Duration',
      durationOption: '{{name}} · {{seconds}}s',
      durationChip: '{{seconds}}s',
      durationMissing: 'No {{seconds}}s',
      durationMissingUnstated: 'Not in this duration',
      formatIcon: 'Motion format',
      stillFormat: 'This format holds still.',
      needsCopy: 'Needs copy this board has not got: {{fields}}',
      notEveryFormat: 'Not every selected format has this length',
    },
    tabs: {
      editor: 'Editor',
      library: 'Library',
      output: 'Output',
      renders: 'Exports',
      rendersDisabled: 'Export to make the first render',
    },
    notice: {
      gotIt: 'Got it',
      neverAgain: "Don't show again",
    },
    coverSheet: {
      title: 'Edit cover image',
      description: 'Pick a picture from brand assets, or upload one.',
      coverChosen: 'Shown on the adset card',
      removeCover: 'Remove cover',
      scopeLabel: 'Which brand assets to show',
      scopeFolder: "This adset's folder",
      scopeAll: 'All brand assets',
      searchPlaceholder: 'Search brand assets',
      loading: 'Loading brand assets…',
      empty: 'No brand assets here yet. Upload one to use as the cover.',
      searchEmpty: 'No brand asset matches "{{search}}".',
      failed: "Couldn't load brand assets.",
      retry: 'Retry',
      save: 'Save',
      cancel: 'Cancel',
      failure: "Couldn't save the cover. Try again.",
    },
    rename: {
      failure: "Couldn't rename the adset. Try again.",
    },
    duplicate: {
      menuItem: 'Duplicate',
      inProgress: 'Duplicating…',
      success: 'Adset duplicated',
      failure: "Couldn't duplicate the adset. Try again.",
    },
    deleteModal: {
      title: 'Delete adset',
      body: 'This removes "{{name}}" from Content Studio. This cannot be undone from here.',
      confirm: 'Delete',
      cancel: 'Cancel',
      success: 'Adset deleted',
      failure: "Couldn't delete the adset. Try again.",
    },
    assistant: {
      threads: {
        newChat: 'New chat',
        chatsInRun: 'Chats in this run',
        switchChat: 'Switch chat',
        chatActions: 'Chat actions',
        rename: 'Rename',
        renameChat: 'Rename chat',
        chatName: 'Chat name',
        duplicate: 'Duplicate',
        delete: 'Delete',
        deleteChat: 'Delete chat',
        loadMore: 'Show more chats',
        loading: 'Loading chats',
        loadError: "Couldn't load chats.",
        retry: 'Retry',
        status: {
          running: 'Thinking',
          failed: 'Failed',
          idle: 'Done',
          empty: 'Empty',
        },
        thinking: 'Thinking…',
        otherChatWorking: 'Another chat is working',
        workingElsewhere: 'The agent is working in "{{title}}".',
        workingElsewhereUntitled: 'The agent is working in another chat.',
        openChat: 'Open chat',
        entireCanvas: 'Entire canvas',
        frames_one: '{{count}} frame',
        frames_other: '{{count}} frames',
        meta: {
          messages_one: '{{count}} message',
          messages_other: '{{count}} messages',
          noMessages: 'No messages yet',
        },
        result: {
          formatsAdded_one: '{{count}} format added',
          formatsAdded_other: '{{count}} formats added',
          formatsRemoved_one: '{{count}} format removed',
          formatsRemoved_other: '{{count}} formats removed',
          formatsEdited_one: '{{count}} format edited',
          formatsEdited_other: '{{count}} formats edited',
          sectionsChanged_one: '{{count}} section changed',
          sectionsChanged_other: '{{count}} sections changed',
        },
        deleteDialog: {
          title: 'Delete "{{title}}"?',
          description:
            "This removes the chat and its messages from this run. The run's formats stay as they are. This can't be undone.",
          confirm: 'Delete chat',
          cancel: 'Cancel',
        },
        toast: {
          deleted: 'Chat deleted',
          duplicated: 'Chat duplicated',
        },
        selectionSwitch: {
          switchedTo: 'Switched to "{{title}}"',
          newChatForFrames_one: 'New chat for {{count}} frame',
          newChatForFrames_other: 'New chat for {{count}} frames',
          newChatForCanvas: 'New chat for the entire canvas',
          undo: 'Undo',
        },
        errors: {
          open: "Couldn't open the chat. Try again.",
          create: "Couldn't start the chat. Try again.",
          rename: "Couldn't rename the chat. Try again.",
          duplicate: "Couldn't duplicate the chat. Try again.",
          delete: "Couldn't delete the chat. Try again.",
          deleteBusy:
            'This chat is working. Wait for it to finish, or stop it, before deleting it.',
        },
      },
      emptyState:
        'Describe the adset to the agent · it will build the library, template and formats from there.',
      inputPlaceholder: 'Message the agent',
      agentName: 'Agent',
      send: 'Send',
      stepDone: 'Done',
      stepFailed: 'Failed',
      stepRunning: 'Running',
      stepUnknown: 'Unknown',
      stepsRunning: 'Working…',
      stepsDone_one: '{{count}} step',
      stepsDone_other: '{{count}} steps',
      rebaseFailure:
        "Couldn't refresh the canvas with the agent's changes. Try refreshing the page.",
      stop: 'Stop',
      jumpToLatest: 'Jump to latest',
      composerBlockedHint: 'Waiting for the agent to finish this turn…',
      holdingPromptHint: 'Waiting for the board to free up before sending…',
      pendingPrompt: 'Waiting to send…',
      thinking: 'Thinking…',
      endedRun: 'The run ended without a reply.',
      sendFailed: "This message wasn't sent. Edit it or send it again.",
      clearChat: 'Clear chat',
      clearChatConfirmTitle: 'Clear this chat?',
      clearChatConfirmDescription:
        "The assistant's conversation history for this chat will be removed for everyone on this board, and the assistant will start fresh. This can't be undone from the app.",
      clearChatConfirm: 'Clear chat',
      clearChatCancel: 'Cancel',
      clearChatFailed: "The chat wasn't cleared. Try again.",
      runFailed: "The agent couldn't finish this turn.",
      attach: 'Attach files',
      attachmentsUploading_one: 'Uploading {{count}} file…',
      attachmentsUploading_other: 'Uploading {{count}} files…',
      attachmentFailed: "Couldn't upload {{filename}}.",
      removeAttachment: 'Remove attachment',
      removeProjectContext: 'Remove project context',
      addProjectContext: 'Add project context',
      projectContextConfirm: 'Add',
      projectContextDialogTitle: 'Add context from project',
      projectContextCancel: 'Cancel',
      projectContextConfirmWithCount: 'Add ({{selectedCount}})',
      projectContextOverLimit: 'Select at most {{max}} items ({{count}} selected).',
      cancelUpload: 'Cancel upload',
      attachmentRejected: "{{filename}} isn't a supported file type.",
      attachmentTooLarge: '{{filename}} is larger than the {{limit}} upload limit.',
      imagePicker: {
        image: 'Image',
        appliesTo_one: '{{count}} output',
        appliesTo_other: '{{count}} outputs',
        background: 'Background',
        boardNotReady: "This board hasn't finished loading, so nothing was changed.",
        noBackgroundWell: 'This board has no background photograph, so nothing was changed.',
        selectPrompt: 'Select the one you would like.',
        unknownWell: "That picture well isn't on this board, so nothing was changed.",
      },
      nextActions: {
        label: 'Suggested next steps',
      },
      selectedFrames_one: '{{count}} frame selected · the agent will focus on it',
      selectedFrames_other: '{{count}} frames selected · the agent will focus on these',
      starterPills: {
        brief: 'Start from a brief',
        figmaFile: 'Upload a Figma file (.fig)',
        reference: 'Build from a reference',
        brandImages: 'Import brand images',
        generateFormats: 'Generate first formats',
        generateAllFormats: 'Generate all ad formats',
        generateAllFormatsPrompt: 'Generate all formats available',
      },
      // One key per raw `llm` tool name declared server-side (`name.user` in each
      // `defineTool`), across both the content-board and output assistants - the label a
      // tool step shows in the transcript.
      tools: {
        add_image_layer: 'Add image layer',
        add_output: 'Add output',
        assign_outputs_to_section: 'Move outputs into section',
        check_outputs: 'Check output fit',
        create_section: 'Create section',
        delete_component: 'Delete component',
        delete_content: 'Delete content layer',
        delete_section: 'Delete section',
        delete_shell: 'Delete shell',
        duplicate_output: 'Duplicate output',
        duplicate_section: 'Duplicate section',
        get_attachment: 'Read attachment',
        get_figma_node: 'Inspect Figma layer',
        get_pack: 'Get pack',
        get_project_context: 'Read project context',
        import_figma: 'Import from Figma',
        import_sheet_images: 'Import sheet images',
        list_assets: 'List assets',
        list_outputs: 'List outputs',
        measure_render: 'Measure render',
        parse_copy_sheet: 'Parse copy sheet',
        pick_images: 'Pick images',
        query_knowledge_base: 'Search knowledge base',
        read_figma: 'Read Figma file',
        read_guide: 'Read guide',
        remove_output: 'Remove output',
        render_pack: 'Render pack',
        replace_tokens: 'Replace tokens',
        save_figma_images: 'Save Figma images',
        set_content: 'Set content',
        set_content_presets: 'Set content presets',
        set_copy: 'Set output copy',
        set_duration: 'Set duration',
        set_image: 'Set output image',
        set_props: 'Set output props',
        set_templates: 'Set templates',
        set_tokens: 'Set tokens',
        tidy_section: 'Tidy section',
        update_section: 'Update section',
        upsert_component: 'Upsert component',
        upsert_shell: 'Upsert shell',
      },
      // The stage a running Figma import is on. The server streams the key, not the sentence,
      // so the sentence is chosen here and reads in the person's own language.
      figmaImportSteps: {
        read: 'Reading the Figma page',
        name: 'Naming the artwork',
        judge: 'Deciding what each thing is',
        artwork: 'Fetching the artwork',
        build: 'Building the creative system',
      },
    },
    leftPanel: {
      tabs: {
        agent: 'Agent',
        layers: 'Layers',
        library: 'Library',
      },
      collapse: 'Collapse panel',
      expand: 'Expand panel',
      resize: 'Resize panel',
      viewAll: 'View all',
      librarySearchPlaceholder: 'Search the library',
      closeLibrarySearch: 'Close search',
      kindHeadings: {
        tokens: 'Tokens',
        atoms: 'Atoms',
        molecules: 'Molecules',
        organisms: 'Organisms',
        layouts: 'Layouts',
      },
      addEntryToCanvas: 'Add {{name}} to canvas',
      addInstanceModal: {
        title: 'Add to canvas',
        confirm: 'Add',
        cancel: 'Cancel',
      },
    },
    // The sections the properties panel stacks its controls into, rendered uppercase.
    controlGroups: {
      text: 'Text',
      placement: 'Placement',
      alignment: 'Alignment & options',
      visibility: 'Visibility',
      motion: 'Motion',
    },
    motionCurves: {
      firstHandle: 'First control point of {{curve}}',
      secondHandle: 'Second control point of {{curve}}',
    },
    // This product's own name for a control the source called something else. `control-labels.ts`
    // resolves an imported identifier to one of these; an identifier absent from that map falls to
    // the name a person gave it, then to the one the import derived, then to `unnamed` - never to
    // the identifier, so no label here is ever the source's own words.
    controlLabels: {
      numbered: '{{label}} {{number}}',
      blockOrder: 'Block order',
      headline: 'Headline',
      subhead: 'Subheading',
      body: 'Body copy',
      ctaLabel: 'Button label',
      title: 'Title',
      description: 'Description',
      caption: 'Caption',
      eyebrow: 'Eyebrow',
      badge: 'Badge text',
      disclaimer: 'Disclaimer',
      legal: 'Legal line',
      captionTitle: 'Caption title',
      captionDescription: 'Caption description',

      showText: 'Show the copy',
      showBody: 'Show the body copy',
      showSubhead: 'Show the subheading',
      showHeadline: 'Show the headline',
      showDisclaimer: 'Show the disclaimer',
      showBadge: 'Show the badge',
      showAccent: 'Show the accent',
      showCta: 'Show the button',
      showLogo: 'Show the logo',
      showCoBrand: 'Show the partner logo',
      showPanel: 'Show the panel',
      showGlass: 'Show the glass panel',
      showCards: 'Show the cards',
      showOffer: 'Show the offer',
      showFreeSpace: 'Show the clear-space guide',

      textAlign: 'Copy alignment',
      textBlock: 'Copy block',
      textPos: 'Copy position',
      columnJustify: 'Copy position in its column',
      headlineSize: 'Headline size',
      headlineColour: 'Headline colour',
      headlineWeight: 'Headline weight',
      headlineFont: 'Headline typeface',

      ctaColour: 'Button colour',
      ctaPadX: 'Button side padding',

      image: 'Image',
      imageFit: 'Image fit',
      productSize: 'Product size',
      logoSize: 'Logo size',
      logoPos: 'Logo position',
      slotPos: 'Slot position',
      slotScale: 'Slot size',

      surface: 'Surface',
      background: 'Background',
      frame: 'Frame',
      glassFrost: 'Glass frost',

      accentMark: 'Accent mark',

      badgeShape: 'Badge shape',
      badgeRadius: 'Badge corner radius',
      badgeSmoothing: 'Badge corner smoothing',
      badgeTilt: 'Badge tilt',

      showWatermark: 'Show the watermark',
      watermarkTilt: 'Watermark tilt',
      watermarkOpacity: 'Watermark opacity',
      watermarkBlend: 'Watermark blend mode',

      cardStyle: 'Card style',
      cardTilt: 'Card tilt',
      cardDepth: 'Card depth',

      unnamed: 'Unnamed control',
      unnamedNotice:
        'Some controls here are unnamed because the import did not say what they do. Each one shows the name the design file uses instead.',
      unnamedNoticeRenameable:
        'Some controls here are unnamed because the import did not say what they do. Each one shows the name the design file uses instead, and clicking a name renames it.',
    },
    controlLabelActions: {
      rename: 'Rename',
    },
    controlFacts: {
      menuLabel: 'Control options',
      menuTitle: 'Show under each control',
      note: 'Design notes',
      sourceName: 'Imported names',
      affects: 'How much it affects',
      affectsMarker: 'affects {{affected}} of {{total}}',
      densityTitle: 'Control density',
      increaseControlSize: 'Increase control size',
      decreaseControlSize: 'Decrease control size',
    },
    sourceName: {
      label: 'Imported name:',
      noteHint: 'Read the design note',
      labelNamed: 'Imported name: {{name}}',
      tokenLabel: 'Token',
      tokenHelp: "This value comes from a token, so it can't be edited here.",
      tokenHelpNamed: "This value comes from the {{reference}} token, so it can't be edited here.",
      notePrefix: 'Note in the design file:',
      showOriginal: 'Show the original note',
      hideOriginal: 'Hide the original note',
    },
    copyEmphasis: {
      highlight: 'Highlight',
      bold: 'Bold',
      accent: 'Accent',
      styles: 'Text styles',
      toolbar: 'Emphasis',
    },
    contentTab: {
      copySetLabel: 'Content preset',
      importedCopy: 'Copy options by language',
      versionHeadline: 'Headline',
      versionLanguage: 'Language code (for example en, es or fr)',
      saveVersionCopy: 'Apply to these versions',
      languageFilter: 'Language',
      allLanguages: 'All languages',
      languageUnconfirmed: 'Language unconfirmed',
      languageHelp:
        'Edit each headline across its associated versions without changing other copy. Apply queues the edit for autosave and undo. Language suggestions can be corrected with a language code; use und when the language is unknown.',
      usedInLayouts: 'Used in: {{layouts}}',
      noLayoutAssociation: 'No layout association recorded',
      sharedCopyEdits: 'Shared copy edits',
      copySetPlaceholder: 'Choose a version',
      layersHeading: 'Layers',
      emptyStateTitle: 'No layers yet',
      emptyStateBody: 'Ask the agent to draft the first layers.',
      requiredBadge: 'Required',
      pictureLayers: {
        heading: 'Pictures',
        holdingNothing: 'Nothing chosen yet',
      },
      renameLayer: 'Rename {{name}}',
      toggleLayer: 'Open or close {{name}}',
      toggleLayerTooltip: 'Open or close',
      collapseAllLayers: 'Collapse all layers',
      expandAllLayers: 'Expand all layers',
      collapseAllTooltip: 'Collapse all',
      expandAllTooltip: 'Expand all',
      saveNameTooltip: 'Save',
      cancelRenameTooltip: 'Cancel',
      layerName: 'Name for {{name}}',
      saveName: 'Save name',
      cancelRename: 'Cancel rename',
      reorderLayer: 'Drag to reorder {{name}}',
      reorderTooltip: 'Drag to reorder',
      nameRefRejected:
        'A name cannot contain “{{ref}}” - the design engine reads that as a reference to a token.',
      rule: {
        offRule: 'Off-rule',
        summaryAnyTag: '{{where}} · any tag',
        summaryTagged_one: '{{where}} · {{count}} tag',
        summaryTagged_other: '{{where}} · {{count}} tags',
        folderAndBelow: '{{name}} + subfolders',
        wholeLibrary: 'Whole library',
        everyFolder: 'Every folder',
        folderHeading: 'Folder',
        change: 'Change',
        tagsHeading: 'Tags within that folder',
        noTags: 'Nothing in this folder is tagged yet.',
        showAll: 'Show all images',
        eligibleHeading: 'Eligible',
        galleryCount_one: '{{count}} image',
        galleryCount_other: '{{count}} images',
        galleryTruncated: 'Showing the first {{count}}. Open the library to search the rest.',
        galleryEmpty: 'Nothing matches this rule.',
        galleryEmptyAction: 'Widen the rule',
        galleryFailed: 'These images could not be loaded.',
        galleryRetry: 'Try again',
        openInLibrary: 'Open in library',
        openInLibraryLabel: 'Open {{name}} in the library',
        everythingElse: 'Everything else',
        folderDialogTitle: '{{name}} · folder',
        searchFolders: 'Search folders',
        noFoldersMatch: 'No folder matches "{{search}}".',
        toggleFolder: 'Expand or collapse {{name}}',
        includeSubfolders: 'Include subfolders',
        subfoldersOn: 'Everything nested below this folder',
        subfoldersOff: 'Only files directly in this folder',
        cancel: 'Cancel',
        applyFolder: 'Use this folder',
      },
      upload: {
        button: 'Upload',
        busy: 'Uploading',
        label: 'Upload images to {{name}}',
        dropHint: 'Drop to upload to {{name}}',
        failed: 'The files could not be uploaded. {{message}}',
        dismissFailure: 'Dismiss',
      },
      library: {
        title: '{{name}} layer',
        subtitle: 'Choosing here sets this layer on every format.',
        acceptedTags: 'Accepted tags',
        tagLegend: 'Library-wide tags, shared across every brand and design system.',
        showAllNote: 'Ignore the rule for this pick',
        searchPlaceholder: 'Search {{count}} images',
        noneSelectedTitle: 'No image selected',
        noneSelectedBody: 'Pick one to see its details and edit its tags.',
        offRuleNote: "Outside this layer's rule. Use it anyway, or add its tag to the rule.",
        unfiled: 'Not in a folder',
        globalTags: 'Global tags',
        globalTagsNote: 'Shared across every brand and design system in the library.',
        useImage: 'Use image',
        useAnyway: 'Use anyway',
        dimensions: 'Dimensions',
        format: 'Format',
        kind: 'Kind',
        placement: 'Placement',
        scene: 'Scene',
        shot: 'Shot',
        orientation: 'Orientation',
        markets: 'Markets',
        license: 'Licence',
      },
    },
    assetsTab: {
      mediaHeading: 'Media',
      assetField: {
        emptyScopeTitle: 'No images yet',
        emptyScopeBody: 'Upload one to use it here.',
        upload: 'Upload an image',
      },
      /** What an image layer draws as, which names an entry of a picture list in the layer list. */
      assetCategory: {
        background: 'Background',
        slot: 'Product image',
        logo: 'Logo',
        mark: 'Accent mark',
        other: 'Other images',
        blastRadiusNotice: 'Applies to every format.',
      },
      componentsHeading: 'Components',
      imagesHeading: 'Images',
      videosHeading: 'Videos',
      mediaEmptyTitle: 'No media yet',
      mediaEmptyBody:
        'This board is not linked to a media folder, so there is nothing to show here.',
      mediaLoading: 'Loading media...',
      mediaFailed: "Couldn't load this folder's media.",
      mediaFolderEmpty: 'Nothing in this folder yet.',
      fontsHeading: 'Fonts',
      fontsFailed: "Couldn't load the brand fonts.",
      emptyStateTitle: 'No components yet',
      emptyStateBody: 'Upload files or ask the agent to build one.',
    },
    library: {
      nameLabel: 'Adset name',
      cardMenu: {
        actionsFor: 'Actions for {{name}}',
        rename: 'Rename',
        duplicate: 'Duplicate',
        editCover: 'Edit cover image',
        delete: 'Delete',
      },
      create: 'New adset',
      createFromScratch: 'Start from scratch',
      createFromZip: 'Import from a pack zip',
      createFromFigma: 'Import from Figma link',
      notPublished: 'Not published',
      emptyDescription:
        'Start from a brief and the studio produces the hero assets and every variation they scale into: formats, channels and markets, each render checked against the brand system it inherits.',
      emptyTitle: 'Create your first adset',
      errorDescription: 'Something went wrong. Please try again.',
      errorTitle: "Couldn't load adsets",
      loadMore: 'Load more',
      newSystemName: 'Untitled adset',
      formatCount_one: '{{count}} format',
      formatCount_other: '{{count}} formats',
      retry: 'Retry',
      searchPlaceholder: 'Search adsets',
      noResultsTitle: 'No adsets match "{{term}}"',
      noResultsDescription: 'Nothing here goes by that name. Try another one.',
      clearSearch: 'Clear search',
      columns: {
        name: 'Name',
        formats: 'Formats',
        updated: 'Updated',
        status: 'Status',
      },
      viewToggle: {
        cardsView: 'Card view',
        listView: 'List view',
      },
      statusActive: 'Active',
      statusArchived: 'Archived',
      title: 'Content studio',
      updated: 'Updated {{when}}',
      updatedBy: 'Updated {{when}} by {{name}}',
      updatedByAssistant: 'Updated {{when}} by {{name}} via Assistant',
      versionCount_one: '{{count}} version',
      versionCount_other: '{{count}} versions',
    },
    import: {
      title: 'Import a brand pack',
      reimportTitle: 'Re-import pack',
      dropzoneLabel: 'Choose a pack zip to build an adset from it',
      dropzone: 'Drop a file here or click to browse',
      dropzoneHint: 'ZIP - Max 200MB',
      reading: 'Reading the pack…',
      unreadableTitle: "Couldn't read that file",
      unreadableBody: 'It does not open as a zip archive.',
      rejectedTitle: 'That file was not accepted',
      rejectedBody: 'Choose a single .zip under 200MB.',
      nameLabel: 'Name',
      summaryLabel: 'What this pack holds',
      summaryPackFiles_one: '{{count}} pack file',
      summaryPackFiles_other: '{{count}} pack files',
      summaryAssets_one: '{{count}} asset',
      summaryAssets_other: '{{count}} assets',
      summarySections_one: '{{count}} section',
      summarySections_other: '{{count}} sections',
      summaryEngine: 'Made for design engine {{range}}. This app runs {{version}}.',
      compat: {
        title: 'This pack may not look the way it was made',
        engineOutOfRange:
          'It was made for design engine {{range}}, and this app runs {{version}}. It may still render: check it once it is imported.',
        validatedWithNewer:
          'It was last checked with design engine {{validatedWith}}, newer than the {{version}} this app runs. Features it relies on may be missing.',
        rangeBelowFeatures:
          'Its pack.json allows design engines older than {{minEngine}}, the oldest this pack can use.',
        manifestInvalid: 'Part of its pack.json could not be read.',
      },
      skippedColourProfiles_one: '{{count}} colour profile is not imported',
      skippedColourProfiles_other: '{{count}} colour profiles are not imported',
      skippedInfo_one: '{{count}} file is left out of the import',
      skippedInfo_other: '{{count}} files are left out of the import',
      skippedProblems_one: "{{count}} file can't be imported",
      skippedProblems_other: "{{count}} files can't be imported",
      skipReason: {
        documentation: "notes for the pack's authors",
        workingFiles: 'working files kept beside the pack',
        renderSpec: 'read only by the command-line renderer',
        displayProxy: 'a display copy; the original is imported',
        notReadYet: 'not read by this importer yet',
        notPackData: 'not part of a pack',
        unreadable: 'could not be read',
        unsupportedType: 'this file type is not supported',
        sidecarWithoutMedia: 'describes a file that is not in the pack',
        sidecarOfSkippedMedia: 'describes a file that is not imported',
        tooLarge: 'larger than the {{limit}} upload limit',
      },
      showList: 'Show the list',
      hideList: 'Hide the list',
      unmappedPaths_one: '{{count}} path in the pack was not matched to an uploaded asset',
      unmappedPaths_other: '{{count}} paths in the pack were not matched to an uploaded asset',
      unmappedPathsListTitle: 'Not matched to an asset',
      errorsTitle: "This pack can't be imported",
      emptyTitle: 'Nothing in here to import',
      emptyBody: 'The zip holds no pack files and no assets this importer recognises.',
      errorInvalidJson: '{{path}} is not valid JSON',
      errorNotAnObject: '{{path}} does not hold a JSON object',
      stageValidating: 'Checking the pack…',
      stagePack: 'Building the adset…',
      stageFolder: 'Creating the Brand Assets folder…',
      stageAssets: 'Uploading assets ({{done}} of {{total}})…',
      assetFailures_one: '{{count}} asset did not upload. Add it in Brand Assets.',
      assetFailures_other: '{{count}} assets did not upload. Add them in Brand Assets.',
      assetWarnings_one:
        '{{count}} font uploaded but stayed untagged, so it will not appear in this library. Tag it in Brand Assets.',
      assetWarnings_other:
        '{{count}} fonts uploaded but stayed untagged, so they will not appear in this library. Tag them in Brand Assets.',
      folderFallbacks_one:
        "{{count}} asset is in the pack's own folder: the sub-folder the pack files it in could not be created. Move it in Brand Assets.",
      folderFallbacks_other:
        "{{count}} assets are in the pack's own folder: the sub-folders the pack files them in could not be created. Move them in Brand Assets.",
      confirm: 'Import',
      cancel: 'Cancel',
      close: 'Close',
      openSystem: 'Open',
      failureTitle: "Couldn't import the pack",
      failureWithoutDetail: 'No reason was reported. Try the import again.',
      partialTitle: 'Imported, but something did not land',
      reportedProblem: 'What went wrong:',
      failureDetailsTitle: 'Every problem found in the pack',
      packWarnings_one: '{{count}} reference in the pack resolves to nothing, so it has no effect',
      packWarnings_other:
        '{{count}} references in the pack resolve to nothing, so they have no effect',
      packWarningsListTitle: 'References that resolve to nothing',
      added: 'Added',
      removed: 'Removed',
      formats: {
        summary: 'Formats: {{parts, list(type: unit)}}',
        matched_one: '{{count}} matched',
        matched_other: '{{count}} matched',
        custom_one: '{{count}} custom',
        custom_other: '{{count}} custom',
        notMatched_one: '{{count}} not matched',
        notMatched_other: '{{count}} not matched',
        unrecognised_one: '{{count}} other',
        unrecognised_other: '{{count}} other',
        matchedLine: '{{shellId}} - {{name}}',
        customLine: '{{shellId}} - Custom',
        chosenLine: '{{shellId}} - {{name}} (chosen over {{others, list}}: {{rule}})',
        chosenLineWithoutRule: '{{shellId}} - {{name}} (chosen over {{others, list}})',
        rule: {
          workspaceFormat: "your organisation's format",
          shellId: 'matched the format id',
          declaredPlacement: 'first fitting canvas of its placement',
        },
        ambiguousLine: '{{shellId}} - Not matched: {{candidates, list(type: disjunction)}}',
        catalogueUnavailableLine: '{{shellId}} - Not matched: the format library could not be read',
        notMatchedLine: '{{shellId}} - Not matched',
        unrecognisedLine: '{{shellId}} - Not described by this version of the app',
      },
    },
    figmaImport: {
      title: 'Import a Figma page',
      description:
        'Select one page in Figma and copy its link from the Share dialog. A link to a frame imports its containing page. Only that page is imported, including its colours, type, formats, artwork and layouts; other pages are not included. Each import creates a new creative system rather than changing an existing one.',
      urlLabel: 'Figma link',
      urlPlaceholder: 'https://www.figma.com/design/…',
      nameLabel: 'Name',
      namePlaceholder: 'Leave empty to use the file’s own name',
      confirm: 'Import the page',
      retry: 'Try again',
      reading: 'Reading the Figma page…',
      progress: '{{label}} ({{completed}} of {{total}})',
      stop: 'Stop',
      cancel: 'Cancel',
      close: 'Close',
      openSystem: 'Open',
      doneTitle: 'Imported',
      doneBody: '{{name}} is ready.',
      failureTitle: "Couldn't import the file",
      failureWithoutDetail: 'No reason was reported. Try again.',
      cancelledTitle: 'Import stopped',
      cancelledBody: 'Nothing was created.',
    },
    canvas: {
      noSpecimen: 'No specimen to draw',
      rename: {
        fieldLabel: 'Frame name',
      },
      placement: {
        moveLayer: 'Move the {{layer}} layer',
        scaleLayer: 'Resize the {{layer}} layer',
      },
      resize: {
        topLeft: 'Resize from the top-left corner',
        top: 'Resize from the top edge',
        topRight: 'Resize from the top-right corner',
        right: 'Resize from the right edge',
        bottomRight: 'Resize from the bottom-right corner',
        bottom: 'Resize from the bottom edge',
        bottomLeft: 'Resize from the bottom-left corner',
        left: 'Resize from the left edge',
      },
      unresolvedAssets_one: "{{count}} image couldn't be resolved",
      unresolvedAssets_other: "{{count}} images couldn't be resolved",
      blankState: {
        title: 'Nothing on the canvas yet',
        body: 'Describe the adset to the agent · it will build the library, template and formats from there.',
      },
      addFormatUnavailable:
        'This board has no template to build a format on yet. Ask the agent for one first.',
      loadingState: {
        title: 'Loading the canvas',
        body: 'Fetching the library, template and formats.',
      },
      errorState: {
        title: "Couldn't load the canvas",
        body: 'Something went wrong. Try again.',
      },
    },
    controlBar: {
      tidy: 'Tidy up',
      shrink: 'Shrink to fit',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      zoomLevel: '{{percent}}%',
      cursorMode: 'Cursor mode',
      select: 'Select',
      pan: 'Pan',
      undo: 'Undo',
      redo: 'Redo',
      addFormat: 'Add a format',
      fitAll: 'Fit all formats',
      togglePanel: 'Toggle design panel',
      withShortcut: '{{label}} ({{chord}})',
      mode: {
        label: 'Rendering mode',
        static: 'Static',
        motion: 'Motion',
      },
    },
    rightPanel: {
      title: 'Properties',
      contentSectionHeading: 'Content',
      emptyStateTitle: 'Nothing to edit',
      emptyStateBody: 'Nothing on the board declares editable properties yet.',
      propUpdateFailure: "Couldn't save that change. Try again.",
      allShellsScope: 'Editing all shells',
      allShellsScopeStatic: 'Editing all static shells',
      allShellsScopeMotion: 'Editing all motion shells',
      selectionScope_one: 'Editing {{count}} shell',
      selectionScope_other: 'Editing {{count}} shells',
      mixedValue: 'Mixed',
      booleanOn: 'On',
      booleanOff: 'Off',
      blocked: {
        lockedColours_one: 'The locked colour',
        lockedColours_other: 'The locked colours',
        needsOff_one: '{{options, list}} needs {{prop}} off',
        needsOff_other: '{{options, list}} need {{prop}} off',
        needsOn_one: '{{options, list}} needs {{prop}} on',
        needsOn_other: '{{options, list}} need {{prop}} on',
        needsOther_one: "{{options, list}} isn't available with the current {{props, list}}",
        needsOther_other: "{{options, list}} aren't available with the current {{props, list}}",
        rule_one: "{{options, list}} isn't available: {{reason}}",
        rule_other: "{{options, list}} aren't available: {{reason}}",
        turnOff: 'Turn off {{prop}}',
        turnOn: 'Turn on {{prop}}',
      },
      rangeLimits: 'Min {{min}} · Max {{max}}',
      clampedToMax: 'Adjusted to the maximum, {{value}}',
      clampedToMin: 'Adjusted to the minimum, {{value}}',
      pointXHint: '0 is the left edge, 1 the right',
      pointYHint: '0 is the top edge, 1 the bottom',
      locked: 'Locked',
      pointX: 'Horizontal',
      pointY: 'Vertical',
      pointXShort: 'X',
      pointYShort: 'Y',
      pointAxisAria: '{{name}} {{axis}}',
      relativeRangeValue: '{{percent}}%',
      relativeRangeHint: 'Each format scales within its own limits',
      renameControl: 'Rename label “{{name}}”',
      collapseAllSections: 'Collapse all sections',
      expandAllSections: 'Expand all sections',
      collapseAllTooltip: 'Collapse all',
      expandAllTooltip: 'Expand all',
      frameName: 'Frame name',
      renameFieldLabel: 'Control name',
      renameHint:
        '<key>Enter</key> to save, <key>Esc</key> to cancel. Applies to every board on this layout.',
      renameClearHint:
        '<key>Enter</key> to save, <key>Esc</key> to cancel. Empty the field to go back to the name it had.',
      renameRefRejected:
        'A name cannot contain “{{ref}}” - the design engine reads that as a reference to a token.',
      affectedCount: 'Affects {{affected}} of {{total}}',
    },
    addFormatSheet: {
      title: 'Add a format',
      searchLabel: 'Search formats',
      searchPlaceholder: 'Search by name, size or ratio',
      platformFilterLabel: 'Filter by platform: {{name}}',
      allFormats: 'All',
      customSize: 'Add custom size',
      formatMeta: '{{w}} x {{h}} · {{aspect}}',
      onBoardBadge: 'On canvas',
      onBoardBadgeHelp: 'This format is already on the canvas. Adding it again makes a second one.',
      onBoardCount_one: '{{count}} on canvas',
      onBoardCount_other: '{{count}} on canvas',
      customSectionTitle: 'Custom',
      customName: 'Custom',
      customNameNumbered: 'Custom {{index}}',
      addCustomSize: 'Add size',
      noResults: 'No formats match that search.',
      libraryLoading: 'Loading formats...',
      libraryUnavailable: 'The format library could not be loaded. Close this and try again.',
      selectedCount_one: '{{count}} selected',
      selectedCount_other: '{{count}} selected',
      selectAllShown: 'Select all shown',
      selectGroup: 'Select all in {{name}}',
      clearSelection: 'Clear selection',
      confirmWithCount: 'Add ({{count}})',
      widthLabel: 'Width',
      heightLabel: 'Height',
      widthPlaceholder: 'e.g. 1080',
      heightPlaceholder: 'e.g. 1350',
      unitSuffix: 'px',
      confirm: 'Add',
      cancel: 'Cancel',
      validationRequired: 'Enter a width and a height',
      validationRange: 'Width and height must be whole numbers between {{min}} and {{max}} pixels',
    },
    addOutputFormatSheet: {
      noFormats: 'This board has no formats yet. Create one in the Editor, then add it here.',
      unsaved_one: '{{count}} format is not saved yet. Save it in the Editor to add it here.',
      unsaved_other:
        '{{count}} formats are not saved yet. Save them in the Editor to add them here.',
      static: 'Static',
      motion: 'Motion',
    },
    libraryCanvas: {
      back: 'Back',
      title: 'Library',
      compileFrom: 'the objects templates compile from',
      kindToken: 'Token',
      kindAtom: 'Atom',
      kindMolecule: 'Molecule',
      kindOrganism: 'Organism',
      kindLayout: 'Layout',
      kindProperty: 'Property',
      tokenAtomScoped: 'Resolved per atom during layout',
    },
    run: {
      name: 'Run {{number}}',
      notFound: 'That run no longer exists.',
      list: {
        title: 'Content runs ({{count}})',
        subtitle: 'Select a run to open its generated content',
        searchPlaceholder: 'Search content runs',
        create: 'New run',
        columns: {
          name: 'Run',
          version: 'Version',
          formats: 'Formats',
          lastModifiedBy: 'Last modified by',
          lastModified: 'Last modified',
          renders: 'Renders',
        },
        formatCount_one: '{{count}} format',
        formatCount_other: '{{count}} formats',
        unknownCreator: '—',
        noMatches: 'No runs match "{{query}}"',
        emptyTitle: 'No content runs yet',
        emptyDescription: 'Create a run to generate content from the published version.',
        nothingPublishedTitle: 'Publish a version first',
        nothingPublishedDescription: 'Publish a version from the Editor to create runs.',
        loading: 'Loading runs…',
        loadFailureTitle: 'Runs could not be loaded',
        deleteLabel: 'Delete {{name}}',
        deleteConfirmTitle: 'Delete {{name}}?',
        deleteConfirmDescription: 'Its frames and history are deleted. This cannot be undone.',
        deleteConfirm: 'Delete run',
        deleteCancel: 'Cancel',
        createFailure: "Couldn't create that run. Try again.",
        deleteFailure: "Couldn't delete that run. Try again.",
        publishFirstFailure: 'Publish a version from the Editor before creating a run.',
        lastModifiedByAssistant: '{{name}} via Assistant',
        duplicateLabel: 'Duplicate run (stays on v{{number}})',
        copyName: '{{name}} copy',
        duplicateFailure: 'Could not duplicate this run.',
        archiveLabel: 'Archive {{name}}',
        restoreLabel: 'Restore {{name}}',
        archived: '{{name}} archived',
        restored: '{{name}} restored',
        archiveUndo: 'Undo',
        archiveFailure: "Couldn't update that run. Try again.",
        archivedBadge: 'Archived',
        showArchived_one: 'Show {{count}} archived run',
        showArchived_other: 'Show {{count}} archived runs',
        hideArchived: 'Hide archived runs',
        deleteHasRenders: 'This run has renders, so it can be archived but not deleted.',
      },
      menu: {
        switch: 'Switch run',
        create: 'New content run',
        duplicate: 'Duplicate run',
        delete: 'Delete run',
        rename: 'Rename run',
        archive: 'Archive run',
        restore: 'Restore run',
      },
      renameDialog: {
        title: 'Rename run',
        nameLabel: 'Name',
        save: 'Save',
        cancel: 'Cancel',
        nameTooLong: 'Name must be {{max}} characters or fewer',
      },
    },
    renders: {
      name: 'Render {{number}}',
      byLine: '{{name}} · {{when}}',
      settingsStatic: '{{format}} @{{scale}}x',
      settingsVideo: 'MP4',
      settingsVideoRenderer: 'MP4 · {{renderer}}',
      renderers: {
        resvg: 'A · resvg',
        canvas2d: 'B · Chrome Canvas 2D',
        dom: 'C · Chrome DOM',
      },
      formats: {
        png: 'PNG',
        jpg: 'JPG',
        webp: 'WebP',
        pdf: 'PDF',
        mp4: 'MP4',
        gif: 'GIF',
        mov: 'MOV',
        webm: 'WebM',
      },
      loading: 'Loading renders…',
      loadFailure: 'Renders could not be loaded',
      emptyTitle: 'No renders yet',
      emptyDescription: 'Export from Output to render this run as files.',
      progress: {
        ready: '{{ready}} of {{total}} ready',
        failed_one: '{{count}} failed',
        failed_other: '{{count}} failed',
        rendering: 'Rendering {{done}} of {{total}}',
        renderingNow_one: '{{count}} rendering',
        renderingNow_other: '{{count}} rendering',
        queued_one: '{{count}} queued',
        queued_other: '{{count}} queued',
        showFailed: 'Show failed files: {{label}}',
        showQueue: 'Show what is in progress: {{label}}',
      },
      actions: {
        download: 'Download',
        downloading: 'Downloading…',
        downloadFailed: "Couldn't download. Try again.",
        save: 'Save to board',
        saveSelected: 'Save ({{count}})',
        saving: 'Saving…',
        pickProject: 'Choose a project',
        pickFolder: 'Choose a folder',
        noFolders: 'This project has no folders',
        noUploadPermission: "You can't upload to this project",
        saveSuccess_one: '{{count}} file saved to {{folder}}',
        saveSuccess_other: '{{count}} files saved to {{folder}}',
        savePartial: 'Saved {{saved}} of {{total}}. {{failed}} failed.',
        saveFailed: "Couldn't save. Try again.",
        saveInProgress_one: 'Saving {{count}} file to {{folder}}',
        saveInProgress_other: 'Saving {{count}} files to {{folder}}',
        saveInProgressDetail: "You can keep working. We'll let you know here when it's done.",
        saveStillRunning: 'Still saving to {{folder}}',
        saveStillRunningDetail: 'Files will keep arriving in the folder.',
        retry_one: 'Retry {{count}} failed',
        retry_other: 'Retry {{count}} failed',
        retryFailed: "Couldn't retry. Try again.",
      },
      file: {
        queued: 'Queued',
        rendering: 'Rendering',
        ready: 'Ready',
        failed: 'Failed',
        select: 'Select {{name}}',
        open: 'Open {{name}}',
        enlarge: 'Open full size',
        size: '{{w}}×{{h}}',
        frameRemoved: 'Its frame has since been removed',
        readyFontMissing: 'Ready · font missing',
        fontMissing_one:
          'Font missing: {{families, list}}. Text set in it was drawn in a fallback font. Add it to Brand Assets, then export again.',
        fontMissing_other:
          'Fonts missing: {{families, list}}. Text set in them was drawn in a fallback font. Add them to Brand Assets, then export again.',
      },
      rail: {
        title: 'Exports',
        newExport: 'New export',
        show: 'Show exports',
        hide: 'Hide exports',
        percent: '{{value}}%',
      },
      side: {
        show: 'Show details',
        hide: 'Hide details',
      },
      queue: {
        title: 'In progress',
        now: 'Rendering now',
        next: 'Up next',
        queued_one: '{{count}} queued',
        queued_other: '{{count}} queued',
        more_one: 'and {{count}} more',
        more_other: 'and {{count}} more',
        show: 'Show in exports',
        empty: 'Nothing is rendering right now.',
      },
      rename: {
        label: 'Render name',
        tooltip: 'Rename',
        failed: "Couldn't rename the render. Try again.",
      },
      archive: {
        menu: 'Render actions',
        archive: 'Archive',
        restore: 'Restore',
        badge: 'Archived',
        archived: '{{name}} archived',
        restored: '{{name}} restored',
        undo: 'Undo',
        failed: "Couldn't update the render. Try again.",
        show_one: 'Show {{count}} archived render',
        show_other: 'Show {{count}} archived renders',
        hide: 'Hide archived renders',
      },
      view: {
        search: 'Search file names',
        clearSearch: 'Clear search',
        show: 'Show',
        status: {
          all: 'All',
          ready: 'Ready',
          progress: 'In progress',
          failed: 'Failed',
        },
        filters: 'Filters',
        filtersActive: 'Filters · {{count}}',
        clearFilters: 'Clear all filters',
        dimension: {
          kind: 'Format',
          format: 'File type',
          channel: 'Channel',
          size: 'Size',
        },
        kind: {
          static: 'Static',
          video: 'Video',
        },
        customChannel: 'Custom format',
        group: 'Group',
        groupActive: 'Group · {{name}}',
        grouping: {
          none: 'No grouping',
          status: 'Status',
        },
        groupSummary: '{{ready}} ready',
        groupSummaryFailed: '{{ready}} ready · {{failed}} failed',
        shown_one: '{{count}} file',
        shown_other: '{{count}} files',
        shownOf: '{{shown}} of {{total}} files',
        selectAll: 'Select all {{count}}',
        selected: '{{count}} selected',
        clearSelection: 'Clear selection',
        noMatchTitle: 'No files match',
        noMatchDescription: 'Clear a filter or the search to see more.',
        clearAll: 'Clear filters',
        filesFailure: "This render's files could not be loaded.",
        retryLoad: 'Try again',
      },
      panel: {
        close: 'Close',
        empty: 'Select a file to see its details.',
        title: 'File details',
        missing: 'This file is no longer part of the render.',
        render: 'Render',
        placement: 'Placement',
        workingFiles: 'Request working files',
        workingFilesFor: 'Source files for {{name}}',
      },
      dialog: {
        trigger: 'Export',
        title: 'Export',
        description: 'Every output renders in its own format. You can follow progress in Exports.',
        nameLabel: 'Name',
        scopeLabel: 'What to export',
        scopeAll: 'All outputs',
        scopeSelection: 'Selection',
        scopeNone: 'none',
        byFormat: 'By format',
        summaryStatic_one: '{{count}} static',
        summaryStatic_other: '{{count}} statics',
        summaryVideo_one: '{{count}} video',
        summaryVideo_other: '{{count}} videos',
        staticTitle: 'Static · {{count}}',
        videoTitle: 'Video · {{count}}',
        staticSpec: 'Default PNG · sRGB · {{scale}}x',
        videoSpec: 'Default MP4 · H.264 · 30 fps',
        files_one: '{{count}} file',
        files_other: '{{count}} files',
        defaultFormat: '{{format}} · default',
        addFormat: 'Add format',
        removeFormat: 'Remove {{format}}',
        comingSoon: 'Coming soon',
        scale: 'Scale',
        scaleOption: '{{value}}x',
        scaleTooLarge: '{{value}}x · too large for {{name}}',
        renderer: 'Renderer',
        cancel: 'Cancel',
        submit_one: 'Export {{count}} file',
        submit_other: 'Export {{count}} files',
        started: '{{name}} started',
        viewInRenders: 'View in Exports',
        failed: "Couldn't start the export. Try again.",
      },
      runCell: {
        none: 'Not rendered',
        readyWithFailed: '{{ready}} of {{total}} ready, {{failed}} failed',
        open: 'Renders: {{status}}',
      },
    },
    versions: {
      draftLabel: 'Draft',
      draftTooltip: 'Unpublished draft · v{{number}}',
      title: 'Versions',
      subtitle: 'Change log, newest first.',
      recordNote:
        'Past versions are a record of what was published. They cannot be opened or restored.',
      info: 'Editing in the editor opens a draft. Runs keep using v{{number}} until you publish it.',
      draftRowTitle: 'Changes in the editor',
      draftNodeTitle: 'Draft · v{{number}}',
      inUse: 'In use',
      versionLabel: 'v{{number}}',
      publish: 'Publish v{{number}}',
      publishing: 'Publishing…',
      publishFailed: 'Publishing failed. Try again.',
      loading: 'Loading versions…',
      loadFailed: 'Versions could not be loaded',
      publishedBy: '{{when}} by {{name}}',
      publishedByAssistant: '{{when}} by {{name}} via Assistant',
      draftBy: 'Changes in the editor, by {{name}}',
      draftByAssistant: 'Changes in the editor, by {{name}} via Assistant',
      label: 'Version label',
      defaultLabel: 'Version {{number}}',
      reimport: 'Re-import',
      unlabelled: 'Unlabelled',
    },
    output: {
      rightPanel: {
        noSelectionTitle: 'Nothing selected',
        noSelectionBody: 'Select an output on the board to edit its properties.',
      },
      node: {
        formatUnset: 'No format',
      },
      imageCrop: {
        reposition: 'Drag to reposition the image',
        zoomReadout: 'image {{zoom}}×',
        topLeft: 'Scale the image from the top-left corner',
        top: 'Scale the image from the top edge',
        topRight: 'Scale the image from the top-right corner',
        right: 'Scale the image from the right edge',
        bottomRight: 'Scale the image from the bottom-right corner',
        bottom: 'Scale the image from the bottom edge',
        bottomLeft: 'Scale the image from the bottom-left corner',
        left: 'Scale the image from the left edge',
      },
      canvas: {
        blankState: {
          title: 'Nothing in this run yet',
          body: "Add a format to start. Each one begins from the system's defaults, or ask the agent to add them.",
        },
        boardUpdateFailure: "Couldn't save that change. Try again.",
        addOutputFailure: "Couldn't add that output. Try again.",
      },
      rail: {
        emptyState:
          'Describe the variation you want. The agent will build it from the outputs on the canvas.',
        inputPlaceholder: 'Message the agent',
      },
      placement: {
        outsideSectionRejected:
          'Drop it inside a section. Outputs cannot sit outside every section.',
        sectionNestedRejected: 'A section cannot sit fully inside another section.',
        sectionStrandedRejected:
          'That would leave an output outside every section, so the section stays as it was.',
      },
      sections: {
        deleteConfirmWithOutputs: 'Delete section and outputs',
        deleteConfirmSectionOnly: 'Delete section only',
        memberCount_one: '{{count}} format',
        memberCount_other: '{{count}} formats',
        headerLabel: 'Section {{name}}',
        problemCount_one: '{{count}} format has a problem',
        problemCount_other: '{{count}} formats have a problem',
        popoverTitle: 'Sections',
        defaultName: 'Section {{count}}',
        add: 'Add a section',
        rename: 'Rename',
        delete: 'Delete',
        renameFieldLabel: 'Section name',
        deleteConfirmTitle: 'Delete section',
        deleteConfirmBody_one: '{{count}} output sits inside this section.',
        deleteConfirmBody_other: '{{count}} outputs sit inside this section.',
        deleteConfirmWithShells: 'Delete section and formats',
        deleteConfirmBodyShells_one: '{{count}} format sits inside this section.',
        deleteConfirmBodyShells_other: '{{count}} formats sit inside this section.',
        deleteConfirmCancel: 'Cancel',
        deleteConfirmConfirm: 'Delete',
      },
      viewSwitch: {
        board: 'Board view',
        table: 'Table view',
      },
      selectionValue: {
        mixed: 'Mixed',
        nothingSelectedTitle: 'Nothing selected',
        nothingSelectedBody:
          "Showing the design's values. Select one or more outputs to edit them.",
      },
      table: {
        groupCount_one: '{{count}} output',
        groupCount_other: '{{count}} outputs',
        headers: {
          asset: 'Asset',
          size: 'Size',
          section: 'Section',
          layout: 'Layout',
          image: 'Image',
          status: 'Status',
        },
        deleteRow: 'Delete output',
        fit: {
          overruns: 'Overflows',
          overrunsReason: 'Some copy runs past its box on this format.',
          refused: 'Refused',
          refusedReason: "The brand pack refuses this format as it is set, so it won't export.",
          unknown: 'Not checked',
          unknownReason:
            "This format hasn't been checked, so nothing is known about it either way.",
        },
        cellInapplicable: 'Not available on this format',
        columnIdentifier: 'Imported name: {{identifier}}',
        columns: {
          copy: 'Copy',
          images: 'Images',
          properties: 'Properties',
          title: 'Columns',
          trigger: 'Columns',
        },
        downloadOptions: 'Download allowed values',
        image: {
          boardLevel: '{{layer}} is set for every format. Change it in the Editor.',
          choose: 'Choose a picture for {{layer}}',
          resetToDesign: "Use the design's picture",
        },
        downloadOptionsFileName: 'output-options',
        options: {
          allowed: 'Allowed values',
          column: 'Column',
          anyText: 'Any text',
          assetId: 'An asset id',
          pointAxes: 'Horizontal and vertical, each 0..1',
          variesByFormat: '(varies by format)',
          key: 'Key',
        },
        download: 'Download',
        exportSheet: 'Export sheet',
        exportTitle: 'Export',
        exportDescription: 'Click to download your sheet to your local device.',
        exportFailed: 'The sheet could not be downloaded.',
        includeAssets: 'Include assets in the download',
        downloadZipMissing_one:
          '{{count}} image could not be fetched, so its cell names the asset id instead.',
        downloadZipMissing_other:
          '{{count}} images could not be fetched, so their cells name the asset id instead.',
        downloadCsvFileName: 'outputs',
        editCellLabel: 'Edit {{column}}. Double-click or press Enter to edit.',
        empty: 'No outputs yet',
        import: {
          trigger: 'Import',
          title: 'Import a sheet',
          description:
            'Bring back a sheet you downloaded from this board. Zip it with the images its rows name and those come in too.',
          dropTitle: 'Drop a CSV or a ZIP here, or click to choose one',
          dropCaption: 'CSV, or a ZIP of the sheet and its images, up to 100MB',
          rejected: "That file wasn't accepted. It has to be a CSV or a ZIP under 100MB.",
          unreadable: "That file couldn't be read as a CSV.",
          tooLarge: 'That archive holds too many files to import.',
          noSheet: 'That archive holds no CSV to import from.',
          manySheets:
            'That archive holds more than one sheet, so there is no way to tell which one to import. Leave just the one.',
          willUploadImages_one: '{{count}} image will be uploaded and bound.',
          willUploadImages_other: '{{count}} images will be uploaded and bound.',
          willBindImages_one: '{{count}} image already in the library will be bound.',
          willBindImages_other: '{{count}} images already in the library will be bound.',
          image: {
            missing:
              'Row {{row}}: the archive holds no image named "{{value}}", so {{layer}} is left as it is.',
            ambiguous:
              'Row {{row}}: "{{value}}" names an image in more than one folder ({{candidates}}). Write the folder into the cell to say which.',
            unsupported: 'Row {{row}}: "{{value}}" is not an image this board can draw.',
            unbound:
              'Row {{row}}: this row matches no output, so its image is not imported either.',
            notPerOutput:
              'Row {{row}}: {{layer}} holds several images on one row, which an output cannot change on its own. Change it on the board.',
          },
          notOurs:
            "This isn't a sheet exported from this board. Attach it in the chat and the assistant can map its columns onto the board for you.",
          willUpdate_one: '{{count}} output will be updated.',
          willUpdate_other: '{{count}} outputs will be updated.',
          willCreate_one: '{{count}} output will be created.',
          willCreate_other: '{{count}} outputs will be created.',
          nothingToApply: 'Nothing in this sheet differs from what the board already says.',
          unchanged_one: '{{count}} row already matches the board.',
          unchanged_other: '{{count}} rows already match the board.',
          unmatched_one: '{{count}} row matches no output and will be skipped: {{rows}}',
          unmatched_other: '{{count}} rows match no output and will be skipped: {{rows}}',
          unmatchedRow: '{{asset}} ({{size}})',
          unknownColumns_one:
            "{{count}} column isn't on this board and will be ignored: {{columns}}",
          unknownColumns_other:
            "{{count}} columns aren't on this board and will be ignored: {{columns}}",
          imagesFailed_one: '{{count}} image could not be filed (row {{rows}}).',
          imagesFailed_other: '{{count}} images could not be filed (rows {{rows}}).',
          stopped:
            'The import stopped before every row was written. Import again to finish it. Outputs already created will not be created a second time.',
          cancel: 'Cancel',
          confirm: 'Import',
          successTitle: 'Copy imported',
          successBody_one: '{{count}} output updated.',
          successBody_other: '{{count}} outputs updated.',
        },
        preview: 'Preview of {{name}}',
        sections: {
          collapse: 'Collapse {{section}}',
          expand: 'Expand {{section}}',
          showAll: 'Show every section',
          title: 'Sections',
          trigger: 'Sections',
          triggerFiltered: 'Sections ({{shown}}/{{total}})',
        },
        selectAll: 'Select all outputs',
        unassignedGroupName: 'No section',
      },
      selectionWrite: {
        failureTitle: "Couldn't update every row",
        failureBody_one: '{{count}} row was rejected: {{rows}}',
        failureBody_other: '{{count}} rows were rejected: {{rows}}',
        failureRow: '{{name}} ({{reason}})',
      },
    },
  },
};
